import { useHistory } from 'react-router-dom';
import { User } from '../../../../@types';
import { canAccessIpaRoute, getIpaRouteFallbackPath } from '../../../../utils/ipaAccess';

export interface CheckUserAllowAccessProps {
  usuario: User | null;
}

export function useCheckUserAllowAccess({ usuario }: CheckUserAllowAccessProps) {
  const history = useHistory();

  if (!usuario || !usuario?.codigoCliente) {
    return null;
  }

  // Mesma decisao e mesmo destino da guarda de rota.
  if (!canAccessIpaRoute(usuario, 'PRICE_OPTIMIZATION')) {
    history.push(getIpaRouteFallbackPath(usuario, 'PRICE_OPTIMIZATION'));
    return null;
  }
}
